import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './Skills.scss';

const Skills = () => {
  // Hardcoded work experiences (already sorted newest first)
  const hardcodedExperiences = [
    {
      year: 'August 2025-*',
      name: 'Founding Software Engineer',
      company: 'Loqol',
      desc: 'Founding Software Engineer at Loqol'
    },
    {
      year: 'May 2025- August 2025',
      name: 'Application Engineer Intern',
      company: 'University Of Phoenix',
      desc: 'Application Engineer Intern at University Of Phoenix'
    },
    
    {
      year: 'December 2021 - May 2024',
      name: 'Software Engineer',
      company: 'Dell Technologies',
      desc: 'Software Engineer at Dell Technologies'
    },
    {
      year: 'May 2021 - December 2021',
      name: 'Software Developer',
      company: 'Kapture CRM',
      desc: 'Software Developer at Kapture CRM'
    },
    {
      year: 'December 2020 - May 2021',
      name: 'Software Engineer Intern',
      company: 'Nomura',
      desc: 'Software Engineer Intern at Nomura'
    }
  ];

  const [experiences] = useState(hardcodedExperiences);
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    const skillsQuery = '*[_type == "skills"]';

    client.fetch(skillsQuery).then((data) => {
      setSkills(data);
    });
  }, []);

  return (
    <>
      <h2 className="head-text">Skills & Experiences</h2>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill.name}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={urlFor(skill.icon)} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
        <div className="app__skills-exp">
          {experiences.map((experience) => (
            <motion.div
              className="app__skills-exp-item"
              key={experience.year + experience.name}
            >
              <div className="app__skills-exp-year">
                <p className="bold-text">{experience.year}</p>
              </div>
              <motion.div className="app__skills-exp-works">
                <>
                  <motion.div
                    whileInView={{ opacity: [0, 1] }}
                    transition={{ duration: 0.5 }}
                    className="app__skills-exp-work"
                    data-tip
                    data-for={experience.name}
                    key={experience.name}
                  >
                    <h4 className="bold-text">{experience.name}</h4>
                    <p className="p-text">{experience.company}</p>
                  </motion.div>
                  <ReactTooltip
                    id={experience.name}
                    effect="solid"
                    arrowColor="#fff"
                    className="skills-tooltip"
                  >
                    {experience.desc}
                  </ReactTooltip>
                </>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, 'app__skills'),
  'skills',
  'app__whitebg',
);
